import React from "react";
import { MultiSelect, Tag } from "@carbon/react";
import Dropdown from "../../Dropdown";
import { getOptionLabel } from "./utils";
import useSelectorState from "./useSelectorState";
import { useTranslation } from "react-i18next";


const Selector = ({ config, value, onChange, parentValue }) => {
  const { t } = useTranslation();
  const {
    label,
    description,
    allow_null = false,
    null_label = "",
  } = config;

  const {
    isMulti,
    fullOptions,
    selectedArray,
    selectedItems,
    selectedSingleItem,
    disabledByDependency,
    handleMultiChange,
    handleSingleChange,
  } = useSelectorState({ config, value, onChange, parentValue });

  return (
    <div className="generic-selector">
      {!!label && (
        <h3 className="generic-selector__label cds--data-table-header__title">
          {label}
        </h3>
      )}

      {isMulti ? (
        <>
          <MultiSelect
            className="generic-selector__multiselect"
            id={`generic-multi-${label}`.replace(/\s+/g, "-")}
            titleText=""
            aria-label={label}
            items={fullOptions}
            itemToString={(item) => getOptionLabel(item)}
            selectedItems={selectedItems}
            onChange={handleMultiChange}
            selectionFeedback="fixed"
            disabled={disabledByDependency}
          />

          <div className="generic-selector__selected">
            {selectedArray.length > 0 ? (
              selectedArray.map((item) => (
                <Tag
                  key={item}
                  size="sm"
                  type="gray"
                  className="generic-selector__tag"
                >
                  {item}
                </Tag>
              ))
            ) : (
              <span className="muted">{t("filters.noSelection")}</span>
            )}
          </div>
        </>
      ) : (
        <Dropdown
          className="generic-selector__select"
          id={`generic-selector-${label}`.replace(/\s+/g, "-")}
          titleText=""
          aria-label={description || label}
          label={getOptionLabel(selectedSingleItem) || (allow_null ? null_label : t("filters.selectOption"))}
          items={fullOptions}
          itemToString={(item) => getOptionLabel(item)}
          selectedItem={selectedSingleItem}
          onChange={handleSingleChange}
          disabled={disabledByDependency}
        />
      )}
    </div>
  );
};

export default Selector;
